import axios from "./axios";

const getTodaysMessages = () => {
  return axios.get("api/dailymessages");
};

const getPage = () => {
  return axios.get("api/settings/general");
};

export { getTodaysMessages, getPage };

const Ams = { getTodaysMessages, getPage };
export default Ams;
